import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="100%"
    height="100%"
    viewBox="0 0 108.8 58.9"
    style={{ enableBackground: "new 0 0 112.7 58.9" }}
    xmlSpace="preserve"
    {...props}
  >
    <style>{`.st0{fill:none;stroke:${strokeColor};stroke-miterlimit:10;}`}</style>
    <g>
      <g>
        <g>
          <g>
            <line className="st0" x1="10.2" y1="32.3" x2="36.9" y2="47.7" />
            <line className="st0" x1="35.5" y1="44.5" x2="10.2" y2="31" />
            <path className="st0" d="M36.2,0.7c2,1.1,6.6,16.3,6.6,16.3" />
            <path className="st0" d="M70.7,0.6c2.9,0.7,12.4,12.5,12,12.7" />
            <path className="st0" d="M70.8,0.7c0-0.2-22.7-0.2-34.7,0.1" />
            <path className="st0" d="M42.7,16.8c0.6,1,24.9-0.4,40-3.5" />
            <path className="st0" d="M107.4,29.5c-1-8.4-12.1-11.4-24.7-16.2" />
            <path className="st0" d="M47.3,54.7c19.1,8.1,46.5-2.8,58.7-6.6" />
            <path className="st0" d="M107.4,29.2c1.8,11.1-0.9,19.2-1.6,18.9" />
            <path className="st0" d="M2.5,22.8c-0.6-4.3,0.3-11.3,1.2-11.3" />
          </g>
          <path className="st0" d="M1.1,20.7c0.1,4.8,0.7,4.7,2,5.5" />
          <ellipse className="st0" cx="41.1" cy="48.7" rx="4.1" ry="9.5" />
          <path className="st0" d="M44.2,38.9c-1.8-4-7.1-5.9-7.8,8.6" />
          <path className="st0" d="M47.4,55c0-14.5-2.1-22.5-7.1-22.1" />
          <path className="st0" d="M35.6,47.1c0-7.7,0.2-13.6,4.7-14.2" />
          <path className="st0" d="M47.1,46.6c-1.3-4.4-2.6-7.2-3.1-8.1" />
          <path className="st0" d="M50.1,55.9c-0.6,1.2-0.5,2.5-2.9,2.6" />
          <path className="st0" d="M39.9,57.6c0,0.8,4.3,0.9,7.5,0.9" />
          <ellipse className="st0" cx="5.9" cy="27.4" rx="2.6" ry="7.5" />
          <path className="st0" d="M13.3,33.8c-0.3,1.5-1.4,1.5-2.6,1.5" />
          <line className="st0" x1="5.9" y1="35.1" x2="10.9" y2="35.4" />
          <path className="st0" d="M10.5,32.6C9.9,23.4,9.7,16,6,15.6" />
          <path className="st0" d="M2.6,25.9C2,16.5,4.3,15.3,6.2,15.6" />
          <path className="st0" d="M8.5,26.6c1.5-6.5-3.5-14-6-5.1" />
          <ellipse className="st0" cx="5.9" cy="28" rx="0.6" ry="1.4" />
          <ellipse className="st0" cx="41.2" cy="49.4" rx="0.9" ry="1.9" />
        </g>
      </g>
    </g>

    {/* Extra lines and elements outside grouped structure */}
    <line className="st0" x1="41.1" y1="39.2" x2="41.2" y2="47.5" />
    <line className="st0" x1="44.9" y1="45.1" x2="41.8" y2="48.1" />
    <line className="st0" x1="40.3" y1="50.2" x2="37.5" y2="53.3" />
    <line className="st0" x1="37.2" y1="45.5" x2="37.2" y2="45.5" />
    <line className="st0" x1="41.2" y1="51.3" x2="41.1" y2="58.2" />
    <line className="st0" x1="42" y1="50" x2="45.2" y2="51.3" />
    <line className="st0" x1="40.4" y1="48.7" x2="37" y2="47.1" />
    <line className="st0" x1="5.9" y1="19.9" x2="5.9" y2="26.6" />
    <line className="st0" x1="5.9" y1="29.5" x2="5.6" y2="34.5" />
    <path className="st0" d="M3.3,28" />
    <path className="st0" d="M4.9,28" />
    <line className="st0" x1="6.5" y1="28.9" x2="8" y2="30.7" />
    <line className="st0" x1="3.7" y1="24.1" x2="5.3" y2="27.4" />
    <line className="st0" x1="5.2" y1="28.5" x2="3.5" y2="29.9" />
    <line className="st0" x1="8.2" y1="25.4" x2="6.5" y2="27.7" />
  </svg>
);
export default SvgComponent;
